import clsx from 'clsx';
import styles from './styles.module.scss';
import ShopRectangleDown from '@/components/icons/shop/RectangleDown';
import { BaseButton, type BaseButtonProps } from '@/components/common/base-button';
import { getHSize, getSize } from '@/utils/size';
import useBaseSize from '@/hooks/useBaseSize';

interface ShopFnbFacilityTriggerBuildingButtonProps extends BaseButtonProps {
    title: string;
    isActive: boolean;
    onClick: () => void;
}

const ShopFnbFacilityTriggerBuildingButton = ({ title, isActive, onClick, ...props }: ShopFnbFacilityTriggerBuildingButtonProps) => {
    const { baseWidth, baseHeight } = useBaseSize();

    return (
        <BaseButton className={styles['trigger-button']} onClick={onClick} {...props}>
            <span>{title}</span>
            <ShopRectangleDown
                className={clsx(styles['trigger-button__icon'], { [styles['trigger-button__icon--active']]: isActive })}
                width={getSize(20, baseWidth)}
                height={getHSize(10, baseHeight)}
            />
        </BaseButton>
    );
};

export default ShopFnbFacilityTriggerBuildingButton;
